// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-multiple-contact-forms .grayscale:hover img{filter:grayscale(0)!important;transform:scale(1.1)}.section-multiple-contact-forms strong{--text-opacity:1;color:#26408a;color:rgba(38,64,138,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
